export const quantityFields = ["loaded_tons", "delivered_tons", "hourly_rate_override", "loading_tonne_rate_override", "fixed_rate_override"];
const own = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key);
const canonicalValue = (row, order, field) => own(row.quantity_base?.[order?.id], field)
  ? row.quantity_base[order.id][field] : order?.[field] ?? null;
export const sameQuantity = (a, b) => (a == null || a === "") ? b == null || b === ""
  : b != null && b !== "" && Number(a) === Number(b);

export function quantityBaselines(row, quantities) {
  const result = {};
  const orders = new Map(row.visits.flatMap(v => v.orders).map(o => [o.id, o]));
  const saved = new Map((row.quantity_drafts || []).map(q => [q.order_id, q]));
  for (const [oid, values] of Object.entries(quantities)) {
    result[oid] = {};
    for (const field of quantityFields.filter(f => own(values, f) || (row.status === "draft" && f === "loaded_tons" && own(values, "delivered_tons")))) {
      if (own(row.quantity_baselines?.[oid], field)) result[oid][field] = row.quantity_baselines[oid][field];
      else if (!own(saved.get(oid), field)) result[oid][field] = canonicalValue(row, orders.get(oid), field);
    }
  }
  return result;
}

export function refreshQuantityDraft(row, next, quantities) {
  const byId = new Map(next.visits.flatMap(v => v.orders).map(o => [o.id, o]));
  const bases = quantityBaselines(row, quantities);
  const refreshed = Object.fromEntries(Object.entries(quantities).map(([oid, values]) => [oid, { ...values }]));
  for (const [oid, values] of Object.entries(refreshed)) {
    for (const field of quantityFields.filter(f => own(values, f))) {
      if (own(bases[oid], field) && sameQuantity(values[field], bases[oid][field])) {
        values[field] = byId.get(oid)?.[field] ?? "";
        bases[oid][field] = canonicalValue(next, byId.get(oid), field);
      }
    }
  }
  return { quantities: refreshed, row: { ...row,
    quantity_mode: row.quantity_mode || next.quantity_mode,
    quantity_base: next.quantity_base, quantity_guard_versions: next.quantity_guard_versions,
    quantity_baselines: Object.fromEntries([...new Set([...Object.keys(next.quantity_baselines || {}), ...Object.keys(bases)])]
      .map(oid => [oid, { ...next.quantity_baselines?.[oid], ...bases[oid] }])),
    quantity_drafts: next.quantity_drafts,
    visits: row.visits.map(visit => ({ ...visit, orders: visit.orders.map(order => ({ ...order,
      ...Object.fromEntries(quantityFields.map(f => [f, byId.get(order.id)?.[f] ?? null])) })) })) } };
}

export function quantityConflictDetails(error) {
  const detail = error?.payload?.detail;
  return detail?.code === "quantity_conflict" ? detail : null;
}
